if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('select[name="locale_code"], input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', () => {
            this.hidePanel();
            this.elements.button.focus();
          });
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        this.languageSelect = this.querySelector('select[name="locale_code"]');
        if (this.languageSelect) {
          this.languageSelect.classList.add('hidden');
          this.elements.button.classList.remove('hidden');
          this.querySelector('.ns-language-picker__caret').classList.add('hidden');
          const form = this.languageSelect.form;
          form.addEventListener('submit', () => window.clearTimeout(this.languageChangeTimer));
          this.languageSelect.addEventListener('change', () => {
            this.elements.button.querySelector('span').textContent = this.languageSelect.selectedOptions[0].textContent.trim();
            this.querySelectorAll('a[data-value]').forEach((item) => {
              const selected = item.dataset.value === this.languageSelect.value;
              item.toggleAttribute('aria-current', selected);
              if (selected) item.setAttribute('aria-current', 'true');
              item.firstElementChild.classList.toggle('visibility-hidden', !selected);
            });
            window.clearTimeout(this.languageChangeTimer);
            this.languageChangeTimer = window.setTimeout(() => {
              if (CSS.supports('selector(:tool-form-active)') && form.matches(':tool-form-active')) return;
              form.requestSubmit();
            }, 0);
          });
        }
        this.onDocumentPointerDown = (event) => {
          if ((!this.contains(event.target) || event.target.classList.contains('country-selector__overlay')) && !this.elements.panel.hidden) this.hidePanel();
        };
      }

      connectedCallback() {
        document.addEventListener('pointerdown', this.onDocumentPointerDown);
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        window.clearTimeout(this.languageChangeTimer);
        if (!this.elements.panel.hidden) this.hidePanel();
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer')?.classList.remove('country-selector-open');
        if (this.header) this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const key = event.code.toUpperCase();
        if (key === 'SPACE' && event.target.matches('a[data-value]')) {
          event.preventDefault();
          event.target.click();
          return;
        }
        if (!['ARROWUP', 'ARROWDOWN', 'HOME', 'END'].includes(key)) return;
        const focusableItems = Array.from(this.querySelectorAll('a[data-value]')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        if (!focusableItems.length) return;
        event.preventDefault();
        const focusedItemIndex = focusableItems.indexOf(document.activeElement);
        if (this.elements.panel.hidden) this.openSelector();
        let index;
        if (key === 'HOME') index = 0;
        else if (key === 'END') index = focusableItems.length - 1;
        else if (key === 'ARROWUP') index = focusedItemIndex > 0 ? focusedItemIndex - 1 : focusableItems.length - 1;
        else index = focusedItemIndex < focusableItems.length - 1 ? focusedItemIndex + 1 : 0;
        focusableItems[index].focus();
        if (this.elements.search) {
          this.elements.search.setAttribute('aria-activedescendant', focusableItems[index].id);
        }
      }

      onContainerKeyUp(event) {
        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            event.preventDefault();
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        this.hidePanel();
        if (this.languageSelect) this.languageSelect.dispatchEvent(new Event('change', { bubbles: true }));
        else if (form) form.requestSubmit();
      }

      openSelector() {
        if (!this.elements.panel.hidden) {
          this.hidePanel();
          return;
        }
        document.querySelectorAll('localization-form').forEach((selector) => {
          if (selector !== this && selector.elements?.panel && !selector.elements.panel.hidden) selector.hidePanel();
        });
        this.elements.button.focus();
        this.elements.panel.hidden = false;
        this.elements.button.setAttribute('aria-expanded', 'true');
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) this.elements.search.focus();
        if (this.header && this.hasAttribute('data-prevent-hide')) this.header.preventHide = true;
        document.querySelector('.menu-drawer')?.classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}

